import { useMemo, useRef } from 'react';
import { useReactNodeView } from '../utils/ReactNodeView';
import { jsx as _jsx } from "react/jsx-runtime";
export default function MeetingTimesView() {
  const context = useReactNodeView();
  const initialAttrs = useMemo(() => context.node ? context.node.attrs : {}, [context.node]);
  const attrs = useRef(initialAttrs);
  return /*#__PURE__*/_jsx("div", {
    dangerouslySetInnerHTML: {
      __html: attrs.current.timeBlockContent
    }
  });
}
export const meetingTimesViewUpdateFn = ({
  previousNode,
  node
}) => {
  if (previousNode.attrs.timeBlockContent !== node.attrs.timeBlockContent) {
    return false;
  }
  return true;
};